import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from "@angular/forms";
import { AdminService } from "../service/admin.service";
import { LoadingController, ModalController, IonModal, ToastController, Platform, PopoverController } from "@ionic/angular";
import { Constant } from "../shared/model/Constant";
import { AuthService } from "../service/auth.service";
import { IntegrationService } from "../service/integration.service"
import { CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ImageValidationService } from "../service/image-validation.service"
import { UsernameValidationService } from '../service/username-validation.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'; //import temporal para asegurar url en desarrollo de registro de imagenes
import { PopoverContentComponent } from '../popover-content/popover-content.component';
import { MapGeolocationComponent } from '../map-geolocation/map-geolocation.component';



@Component({
  selector: 'app-shops',
  templateUrl: './shops.page.html',
  styleUrls: ['./shops.page.scss'],
})
export class ShopsPage implements OnInit {


  @ViewChild('form', { static: false }) ngForm: NgForm;
  @ViewChild(PopoverContentComponent) PopoverContentComponent: PopoverContentComponent;
  
  contacts: any[] = [{}];
  flagNaturalPerson: any;
  documents: any;
  loading: any;
  typeaccounts: any[];
  banks: any[];
  accountNumber: any;
  countries: any[];
  departments: any[];
  cities: any[];
  socialNetworkn: any[] = [{}];
  socialNetworks: any;
  areas: any;
  fileType: string;
  urlRutUploaded: string;
  urlIdPhotocopyUploaded: string;
  urlBankCertificationUploaded: string;
  urlContractUploaded: string;
  taxRegimes: any;
  taxRegimeId: number;
  select = false;
  document: any;
  phone: any;
  cellPhone: any;
  nitdigit: any;
  firstName: any;
  secondName: any;
  firstLastName: any;
  secondSurName: any;
  cellPhoneRep: any;
  commerceId: string;
  user_id: string;
  isFormDatashopsComplete = false;
  isFormAccountingInformationShops = false;
  documentRep: any;
  isFormContactsShops = false;
  isFormDocumentsShops = false;
  isFormBillingShops = false;
  isFormBusinessInformation = false;
  isFormSocialNetworknShops = false;
  isFormCosigners = false;
  isFormStatements = false;
  isFormBilling = false;
  isFormPayments = false;
  webPage: string;
  businnescategories: any[];
  phoneRep: any;
  administrativeExpenses: any;
  providersDebt: any;
  salesMonthly: any;
  inventoryValue: any;
  businnesHousings: any;
  classCiiu: string;
  activities: any[] = [];
  filteredActivities: any[] = [];
  selectedActivity: any = null;
  formattedProvidersDebt: string;
  auxProvidersDebt: string | number;
  amount: any;
  auxamount: string | number;
  providersDebt2: any;
  test: string;
  auxSalesMonthly: number;
  auxAdministrativeExpenses: string | number;
  auxInventoryValue: string | number;
  registeredBy: any;
  disableSaveButton = false;   //expresion para deshabilitar el boton de guardar en seccion informacion contable
  //PARA EXTRAER LA UBICACION
  address: any;
  cityName: any;
  latUser: any;
  lngUser: any;
  plusCodeUser: any;
  cityId: any;
  departmentId: any;
  countryId: any;
  isMobile: any;
  modalOpen: any;
  //PARA CONFIGURACION DE CORTES Y FACTURACIÓN
  configCourt: any[] = [{}];//este arreglo se editara para alterar las opciones de los campos desplegables
  originalConfigCourt: any[] = [{}];// auxiliar que guarda los valores originales de configuraciones de corte
  typeSettlement: any[] = [{}];//
  typeCourts: any[] = [{}];//
  filteredConfigCourt: any[] = [];//
  settlementTypeId: any;//
  paymentMethods: any[] = [{}];
  //PARA REGISTRO DE FOTOS DE COMERCIO
  imagesCommerce: { file: File, url: SafeUrl, typePhoto: number }[] =
    [{ file: null, url: null, typePhoto: null }];
  progress: number[] = [0, 0, 0];
  showProgress: boolean[] = [false, false, false];
  popoverTitle: any = 'Al cargar la foto, ten en cuenta:';
  popoverMessage1: any = 'Aceptamos imágenes de hasta 5MB. Intenta que sean del tamaño de las fotos que tomas con tu teléfono.';
  popoverMessage2: any = 'También te recomendamos cargar imágenes rectangulares con medidas aproximadas de 1200x900 píxeles.';
  popoverMessage3: any = 'Aceptamos imágenes de hasta 5MB.  ';
  popoverMessage4: any = 'También te recomendamos cargar imágenes cuadradas. ';
  popover: any;
  typePhotos: any[];
  selectType: any;
  validRed: boolean = true;        //valida que todos las cuentas esten validas
  validationStatus: boolean[] = [true];  //valida que el nombre de la cuenta de cada red social este valido
  fileName: any[] = [];
  showSinglePhotoOption: boolean = false;
  selectedCategory: number;
  originalFiles: any[] = []; //arreglo para almacenar la imagen original cargada para poder restaurarla si esta ha pasado por el proceso de recorte
  //Variables para categoria En linea
  LogoImage: any = null;
  fileUrl: any;
  userId: string;
  finalFileLogo: any;
  commerce_userid: any;
  constructor(
    private authService: AuthService,
    private adminService: AdminService,
    private integrationService: IntegrationService,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public modalController: ModalController,
    public popoverController: PopoverController,
    private currencyPipe: CurrencyPipe,
    private platform: Platform,
    private imageValidationService: ImageValidationService,
    private userValidationService: UsernameValidationService,
    private sanitizer: DomSanitizer) {
    this.userId = localStorage.getItem(Constant.userId);


  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    await this.loading.present();
    this.getTypePhotosShops();
    this.getBusinessActivityCiiu();
    this.getCountries();
    this.getDepartmentsCountries();
    this.getCitiesDepartments();
    this.getSocialNetworks();
    this.getAreaDirectories();
    this.getFiscalResponsibility();
    this.getCategoryBusiness();
    this.getTypeIdentificationId();
    this.getTypeaccountbank();
    this.getBanks();
    this.filteredActivities = [];
    this.getTypeHousing();
    this.verifyPlatform();
    this.getTypeCourtsFrequencies();               //metodos para extraer info de cortes
    this.getTypesSettlement();
    this.getConfigCourt();
    this.getPaymentMethods();
    this.registeredBy = localStorage.getItem("user_id");    //capturamos el registeredBy cuando se cargue la pagina para no calcularlo en cada paso del formulario

  }

  async loadMap() {
    try {
      if (!this.address) {
        this.presentToast("Por favor ingresa una dirección para abrir el mapa");
        return
      }
      if (this.modalOpen) {
        console.log("Ya hay un modal abierto.");
        return
      }
      this.getCityNameById(); 
      const modal = await this.modalController.create({
        component: MapGeolocationComponent,
        componentProps: {
          address: this.address || null,
          cityName: this.cityName || null,
          latUser: this.latUser || null,
          lngUser: this.lngUser || null
        }
      });
      this.modalOpen = true;
      await modal.present();
      await modal.onWillDismiss().then((response: any) => {
        const data = response.data;
        if (data) {
          console.log('Resultado del proceso de geolocalización', data);
          this.address = data.address;
          this.latUser = data.latitude;
          this.lngUser = data.longitude;
          this.plusCodeUser = data.plusCode;
          this.presentToast("Datos de la ubicación seleccionada obtenidos exitosamente")
        } else {
          this.presentToast("No se pudo realizar el proceso de geolocalización");
        }
        this.modalOpen = false;
      });
    } catch (error) {
      console.error("Error en el proceso de localizacion de los datos geograficos", error);
      this.modalOpen = false;
    }
  }

  verifyPlatform() {
    console.log('platform: ', this.platform.platforms());
    if (this.platform.is('desktop')) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
    console.log('respuesta movil', this.isMobile);
  }

  log() {
    console.log(this.flagNaturalPerson)
  }

  async addContact() {
    this.contacts.push({});
  }

  async removeContact(index: number) {
    this.contacts.splice(index, 1);
  }


  async addSocialNeworks() {
    this.socialNetworkn.push({});
    this.validationStatus.push(true); // Añade una entrada de estado de validación correspondiente
    console.log(this.socialNetworkn);

  }

  async removeSocialNeworks(index: number) {
    this.validationStatus.splice(index, 1);
    this.validRed = this.isAllValid();
    this.socialNetworkn.splice(index, 1);
  }

  getTypeIdentificationId() {
    this.loading.present();
    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
      console.log(this.documents)
      this.loading.dismiss();
    });
  }

  getTypeaccountbank() {
    this.loading.present();
    this.adminService.getTypeaccountbank().subscribe((res: any) => {
      this.typeaccounts = res;
      console.log(this.typeaccounts)
      this.loading.dismiss();
    });
  }

  getBanks() {
    this.loading.present();
    this.adminService.getBanks().subscribe((res: any) => {
      this.banks = res;
      console.log(this.banks)
      this.loading.dismiss();
    });
  }

  getCategoryBusiness() {
    this.loading.present();
    this.adminService.getCategoryBusiness().subscribe((res: any) => {
      this.businnescategories = res;
      console.log(this.businnescategories)
      this.loading.dismiss();
    });

  }

  getTypeHousing() {
    this.loading.present();
    this.adminService.getTypeHousing().subscribe((res: any) => {
      this.businnesHousings = res;
      console.log(this.businnesHousings)
      this.loading.dismiss();
    });

  }

  getBusinessActivityCiiu() {
    this.loading.present();
    this.adminService.getSupplierBusinessActivityCiiu().subscribe((res: any) => {
      this.activities = res;
      console.log(this.activities)
      this.loading.dismiss();
    });
  }

  getCountries() {
    this.loading.present();
    this.adminService.getCountries().subscribe((res: any) => {
      this.countries = res;
      this.loading.dismiss();
    });
  }

  getDepartmentsCountries(countryId?) {
    this.loading.present();
    this.adminService.getDepartments(countryId).subscribe((res: any) => {
      this.departments = res;
      this.loading.dismiss();
    });
  }

  getCitiesDepartments(departmentId?) {
    this.loading.present();
    this.adminService.getCities(departmentId).subscribe((res: any) => {
      this.cities = res;
      this.loading.dismiss();
    });
  }

  getSocialMediaUrl(id: any) {
    if (this.socialNetworks) {
      const socialNetwotk = this.socialNetworks.filter(i => i.socialNetworkId === id);
      if (socialNetwotk.length > 0) {
        const url = socialNetwotk[0].logoUrl;
        return url;
      }
    }
  }


  getSocialNetworks() {
    this.loading.present();
    this.adminService.getSocialNetworks().subscribe((res: any) => {
      this.socialNetworks = res;
      console.log(this.socialNetworks)
      this.loading.dismiss();
    });
  }

  getAreaDirectories() {
    this.loading.present();
    this.adminService.getContactAreaDirectories().subscribe((res: any) => {
      this.areas = res;
      console.log(this.areas)
      this.loading.dismiss();
    });
  }

  getFiscalResponsibility() {
    this.loading.present();
    this.adminService.getFiscalResponsibility().subscribe((res: any) => {
      this.taxRegimes = res;
      this.loading.dismiss();
    });

  }

  getCityNameById() {
    const indexCity = this.cities.findIndex(city => city.cityId === this.cityId);
    const indexDpt = this.departments.findIndex(dept => dept.departmentId === this.departmentId);
    this.cityName = this.cities[indexCity].name + ', ' + this.departments[indexDpt].name;      //variable con nombre de ciudad, departamento y pais para ubicar la ciudad sin margen de error
  }




  changeRuntFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = { route: res.url };
        this.urlRutUploaded = res.url;
        this.adminService.createDocuments(data, null, this.commerceId, null).subscribe((day: any) => {
        })
        this.isFormDocumentsShops = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeIdPhotocopyFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = { route: res.url };
        this.urlIdPhotocopyUploaded = res.url;
        this.adminService.createDocuments(data, null, this.commerceId, null).subscribe((day: any) => {
        })
        this.isFormDocumentsShops = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeBankCertificationFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = { route: res.url };
        this.urlBankCertificationUploaded = res.url;
        this.adminService.createDocuments(data, null, this.commerceId, null).subscribe((day: any) => {
        })
        this.isFormDocumentsShops = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeContractFile(event: any) {
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = { route: res.url };
        this.urlContractUploaded = res.url;
        this.adminService.createDocuments(data, null, this.commerceId, null).subscribe((day: any) => {
        })
        this.isFormDocumentsShops = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }

  }


  selectCheckbox2(checkboxIndex: number) {
    this.taxRegimeId = checkboxIndex;
    this.select = true;
    const checkboxCount = 5;
    for (let i = 0; i < checkboxCount; i++) {
      if (i !== checkboxIndex) {
        const checkboxElement = document.getElementsByClassName('checkbox3')[i] as HTMLIonCheckboxElement;
        checkboxElement.checked = false;
      }
    }
  }


  changeCountry(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getDepartmentsCountries(event.detail.value);
    }
  }


  changeDepartment(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getCitiesDepartments(event.detail.value);
    }
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondSurName) {
      this.secondSurName = String(this.secondSurName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
  }

  validateOnlyLettersArray(index: number) {
    const contact = this.contacts[index];
    if (contact.name) {
      contact.name = contact.name.replace(/[^a-zA-ZñÑ\s]/g, '');
    }
  }


  validateOnlyNumbersShops() {
    if (this.document) {
      this.document = this.document.replace(/\D/g, '');
      this.document = this.document.substring(0, 20);

    }
    if (this.phone) {
      this.phone = this.phone.replace(/\D/g, '');
      this.phone = this.phone.substring(0, 11);
    }
    if (this.cellPhone) {
      this.cellPhone = this.cellPhone.replace(/\D/g, '');
      this.cellPhone = this.cellPhone.substring(0, 11);
    }
    if (this.phoneRep) {
      this.phoneRep = this.phoneRep.replace(/\D/g, '');
      this.phoneRep = this.phoneRep.substring(0, 11);
    }
    if (this.cellPhoneRep) {
      this.cellPhoneRep = this.cellPhoneRep.replace(/\D/g, '');
      this.cellPhoneRep = this.cellPhoneRep.substring(0, 11);
    }
    if (this.nitdigit) {
      this.nitdigit = this.nitdigit.replace(/\D/g, '');
      this.nitdigit = this.nitdigit.substring(0, 2);

    }
    if (this.providersDebt) {
      this.providersDebt = this.providersDebt.replace(/\D/g, '');
      this.providersDebt = this.providersDebt.substring(0, 25);
    }
    if (this.salesMonthly) {
      this.salesMonthly = this.salesMonthly.replace(/\D/g, '');
      this.salesMonthly = this.salesMonthly.substring(0, 25);
    }
    if (this.administrativeExpenses) {
      this.administrativeExpenses = this.administrativeExpenses.replace(/\D/g, '');
      this.administrativeExpenses = this.administrativeExpenses.substring(0, 25);

    }
    if (this.inventoryValue) {
      this.inventoryValue = this.inventoryValue.replace(/\D/g, '');
      this.inventoryValue = this.inventoryValue.substring(0, 25);

    }
    if (this.accountNumber) {
      this.accountNumber = this.accountNumber.replace(/\D/g, '');
      this.accountNumber = this.accountNumber.substring(0, 25);
      this.disableSaveButton = !(/^\d{5,25}$/.test(this.accountNumber));    //condicion que valida el campo numero de cuenta y si la expresion regular se cumple devuelve false, lo que habilita el boton guardar
    }

  }


  validateOnlyNumbersArray(index: number) {
    const contact = this.contacts[index];
    if (contact.phone) {
      contact.phone = contact.phone.replace(/\D/g, '');
    }
  }

  validateOnlyAmount() {
    try {
      if (this.providersDebt) {
        let amountNumber = this.providersDebt.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxProvidersDebt = Number(amountNumber.split(".").join(''));
        this.providersDebt = this.currencyPipe.transform(this.auxProvidersDebt, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.salesMonthly) {
        let amountNumber = this.salesMonthly.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxSalesMonthly = Number(amountNumber.split(".").join(''));
        this.salesMonthly = this.currencyPipe.transform(this.auxSalesMonthly, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.administrativeExpenses) {
        let amountNumber = this.administrativeExpenses.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxAdministrativeExpenses = Number(amountNumber.split(".").join(''));
        this.administrativeExpenses = this.currencyPipe.transform(this.auxAdministrativeExpenses, 'COP', 'symbol-narrow', '1.0-0');
      }
      if (this.inventoryValue) {
        let amountNumber = this.inventoryValue.split("$").join('');
        amountNumber = amountNumber.split(",").join('');
        this.auxInventoryValue = Number(amountNumber.split(".").join(''));
        this.inventoryValue = this.currencyPipe.transform(this.auxInventoryValue, 'COP', 'symbol-narrow', '1.0-0');
      }

    } catch (error) {
      console.log("Error en valor: " + error);
    }
  }


  async basicDataShops(data) {
    //TODO fixme : data mocked
    await this.loading.present();
    if (!this.registeredBy) {
      console.error('User ID no está disponible');
      return;
    }
    data.userId = this.registeredBy;
    data.classCiiu = this.selectedActivity.classCiiu;
    // @ts-ignore
    data.isNaturalPerson = this.flagNaturalPerson === 'true' || this.flagNaturalPerson === true;
    data.latitude = this.latUser;
    data.longitude = this.lngUser;
    data.codePlus = this.plusCodeUser;
    this.authService.createCommerce(data).subscribe((response: any) => {
      this.commerce_userid = response.userId;
      localStorage.setItem(Constant.commerceId, response.commerceId);
      localStorage.setItem(Constant.entityId, response.entityId);
      this.commerceId = response.commerceId;
      this.loading.dismiss();
      this.presentToast('Datos básicos fueron guardados con éxito');
      this.isFormDatashopsComplete = true;
      this.ngForm.reset();
      this.close(true);
    }, error => {
      console.warn('Error al guardar los datos básicos', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar datos básicos');
    });

  }

  filterActivities(event: any) {
    const searchTerm = event.target.value.toLowerCase();

    if (searchTerm.length >= 2) {
      this.filteredActivities = this.activities.filter(activity =>
        activity.name.toLowerCase().includes(searchTerm) ||
        activity.classCiiu.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredActivities = [];
    }
  }

  selectActivity(activity: any) {
    this.selectedActivity = activity;
    this.filteredActivities = [];
    console.log('Esta es la actividad seleccionada:', this.selectedActivity);
  }

  async presentToast(txt, icono?) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      icon: icono ? icono : undefined,
      color: 'primary'
    });
    toast.present();
  }

  async close(data: any) {
    await this.modalController.dismiss(data);
  }

  async accountingInformationShops(value) {
    let response1: any;
    let response2: any;
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    await this.loading.present();
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    // @ts-ignore
    if (this.flagNaturalPerson === 'false') {
      value.identificationTypeRepId = value.typeIdentificationId
    }
    if (!this.registeredBy) {
      console.error('User ID no está disponible');
      return;
    }
    value.registeredBy = this.registeredBy;
    value.userId = this.registeredBy;
    value.taxRegimeId = this.taxRegimeId
    try {
      response1 = await this.authService.accountingInformationShops(this.commerceId, value).toPromise();
      if (!response1) {
        this.presentToast('Error al guardar datos contables');
        this.isFormAccountingInformationShops = false;
      }
      response2 = await this.adminService.saveBankInformationCommerce(this.commerceId, value).toPromise();
      if (!response2) {
        this.presentToast('Error al guardar información bancaria');
        this.isFormAccountingInformationShops = false;
      }
      if (response1 && response2) {
        this.presentToast('Datos contables y bancarios fueron guardados con éxito');
        this.isFormAccountingInformationShops = true;
      }
    } catch (error) {
      console.error('Error al guardar datos contables o información bancaria', error);
      this.isFormAccountingInformationShops = false;
    } finally {
      this.loading.dismiss();
      this.close(true);
    }
  }


  async saveInformationNeworksShops() {
    const commerceId = localStorage.getItem(Constant.commerceId);
    const entityId = localStorage.getItem("entity_id");
    let urlDatabase = null;

    this.socialNetworkn.forEach(socialNetwork => {
      socialNetwork.registeredBy = this.registeredBy;
      socialNetwork.webPage = this.webPage,

        this.adminService.createShopsInformationNeworks(socialNetwork, commerceId).subscribe(res => {
          console.log(res);
          this.presentToast('Datos redes sociales guardados con éxito');
          this.isFormSocialNetworknShops = true;
        }, error => {
          console.warn('Error al guardar redes sociales', error);
          this.loading.dismiss();
          this.isFormSocialNetworknShops = false;
          this.presentToast('Error al guardar redes sociales');
        }
        );
    });
    if (this.selectedCategory !== 5) {
      console.log('Estas son las imagenes que debo guardar: ', this.imagesCommerce);
      const hasFiles = this.imagesCommerce.some(element => element && element.file !== null);   //primero verificamos si han cargado imagenes antes de realizar el proceso.
      if (hasFiles) {       //Sí hay fotos hacemos el proceso de registro de imagenes
        const filesToSave = [];
        const idPhoto = [];   //aca relacionare cada tipo de foto con su foto
        this.imagesCommerce.forEach((element, index) => {
          if (element) {
            filesToSave.push(element.file);
            idPhoto.push(this.typePhotos[index].description);  //aca guardare el nombre de cada foto para enviarlo al registro, debe ir en un arreglo diferente a las fotos para evitar errores
          }
        });
        console.log('ID´s fotos a enviar ', idPhoto);
        this.integrationService.registerImageShops(filesToSave, idPhoto, entityId).subscribe(results => {
          console.log('imagenes registradas en Bucket', results);
          if (Array.isArray(results)) {
            urlDatabase = {
              registeredBy: this.registeredBy,
              typeFiles: results.map((urlFromS3, index) => ({
                typeFileId: this.imagesCommerce[index]?.typePhoto, // Asumiendo que imagesCommerce tiene los typePhoto correspondientes
                urlFile: urlFromS3?.urlS3
              })),
            }
            results.forEach((result, index) => {
              this.fileName[index] = result.fileName;  // Se retorna el nombre con el que cada archivo queda en AWS
            });
            console.log('datos recibidos desde S3 para guardar en base: ', urlDatabase);
          }
          if (urlDatabase === null) {     //verifica que la variable que almacenara el request se haya cargado correctamente
            console.warn('Error al crear el request para metodo de registro de fotos para entidad');
            return;
          }
          this.adminService.savePhotoForEntity(urlDatabase, entityId).subscribe(response => {
            if (Array.isArray(response)) {
              this.presentToast('Se registraron las imagenes para el comercio ' + commerceId + " exitosamente. ");
              console.log('se registraron las imagenes exitosamente ', response);
              this.isFormSocialNetworknShops = true;
            }
          }, error => {
            console.error('Error en proceso de registro de relacion en Base Datos ', error);
            this.isFormSocialNetworknShops = false;
            this.presentToast('No se pudo realizar el registro de las imagenes para el comercio, verifique los archivos e intente nuevamente');
          });

          this.isFormSocialNetworknShops = true;
        }, error => {
          console.error('Error en proceso de registro de las imagenes en AWS ', error);
          this.isFormSocialNetworknShops = false;
          this.presentToast('No se pudo realizar el registro de imagenes para el comercio, verifique los archivos e intente nuevamente');
        });
      } else {
        console.warn('No se han cargado imagenes para registrar', this.imagesCommerce);
      }
    } else {
      //Se inicia proceso si selectedCategory = 5 (Comercio en línea)
      this.adminService.uploadFileLogo(this.finalFileLogo, 'logos', entityId).subscribe((res: any) => {
        this.fileUrl = res.urlS3;
        if (this.fileUrl) {
          console.log("Se carga imagen en la DB");
          this.authService.createStyle(this.userId, { logo: this.fileUrl, userId: this.commerce_userid }).subscribe(value => {
            this.loading.dismiss();
            this.presentToast('Logo Agregado Exitosamente', this.fileUrl);
            console.log("URL DB es")
          });
        } else {
          console.log("Error al cargar el metodo createstyle");
          this.loading.dismiss();
        }
        if (this.fileUrl) {
          this.LogoImage.name = res.fileName;
          console.log("Url del archivo: ", this.fileUrl);
          this.loading.dismiss();
        }
        else {
          this.loading.dismiss();
        }
      }, error => {
        console.log("Error al subir el arvhivo", error);
        this.loading.dismiss();
      });
    }
  }

  async saveContacShops() {
    const commerceId = localStorage.getItem(Constant.commerceId);
    if (!this.registeredBy) {
      console.error('User ID no está disponible');
      return;
    }
    this.contacts.forEach(contact => {
      contact.registeredBy = this.registeredBy;
      this.adminService.createContacts(contact, null, commerceId, null).subscribe(res => {
        console.log(res);
        this.presentToast('Datos básicos de contactos guardados con éxito');
        this.isFormContactsShops = true;
        this.ngForm.reset();

      }, error => {
        console.warn('Error al guardar contactos', error);
        this.loading.dismiss();
        this.presentToast('Error al guardar contactos');
      }
      );
    });
  }

  /*
    openUrl(url: string) {
      if (url) {
        window.open(url);
      }
    }*/

  async accountingInformationBusinessShops(value) {

    if (value.businessCategoryId === this.commerceId) {
      this.showSinglePhotoOption = true;
    } else {
      this.showSinglePhotoOption = false;
    }


    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    await this.loading.present();
    if (!this.commerceId) {
      this.commerceId = localStorage.getItem(Constant.commerceId);
    }
    value.providersDebt = this.auxProvidersDebt;
    value.salesMonthly = this.auxSalesMonthly;
    value.administrativeExpenses = this.auxAdministrativeExpenses;
    value.inventoryValue = this.auxInventoryValue;

    this.authService.accountingInformationBusinessShops(this.commerceId, value).subscribe(response => {
      console.log(this.commerceId, value);

      this.loading.dismiss();
      this.presentToast('Información de negocio guardada con éxito');
      this.isFormBusinessInformation = true;
      this.close(true);
    }, error => {
      console.warn('Error al guardar información de negocio', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar información de negocio');
    });


  }

  addSocialNeworksShops() {
    this.socialNetworkn.push({});
    console.log(this.socialNetworkn);

  }

  getPaymentMethods() {
    this.loading.present();
    this.adminService.getPaymentMethods().subscribe((res: any[]) => {
      this.paymentMethods = res;
      this.loading.dismiss();
    });
  }

  getTypePhotosShops() {
    this.loading.present();
    this.adminService.getTypePhotos().subscribe((res: any[]) => {
      this.typePhotos = res;
      this.loading.dismiss();
    });
  }

  getTypeCourtsFrequencies() {    //extrae los tipos de corte
    this.loading.present();
    this.adminService.getTypesCourt().subscribe((res: any[]) => {
      this.typeCourts = res;
      this.loading.dismiss();
    });
  }

  getTypesSettlement() {    //extrae los tipos de liquidacion
    this.loading.present();
    this.adminService.getTypesSettlement().subscribe((res: any[]) => {
      this.typeSettlement = res;
      this.loading.dismiss();
    });
  }

  getConfigCourt() {    //extrae las configuraciones de corte
    this.loading.present();
    this.adminService.getCourts().subscribe((res: any[]) => {
      this.originalConfigCourt = res;
      this.configCourt = res;
      this.loading.dismiss();
    });
  }

  saveConditions() {
    this.isFormStatements = true;
    this.presentToast('Declaraciones Guardadas');

  }

  async saveCourtConfig(value: any) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    loading.present();
    try {
      let frequency;                 //consulta en la lista de cortes extraidos de base cual coincide con el nombre ó Id del corte seleccionado
      if (value.frequency === 'Semanal' || value.frequency === 'Quincenal' || value.frequency === 'Diario') {
        if (value.frequency === 'Semanal') {
          const sunday = 'Semanal - Día Domingo';   //si es semanal toma unicamente el valor del dia que se hara el corte
          frequency = this.configCourt.filter(i => i.name === sunday);
        } else {
          frequency = this.configCourt.filter(i => i.name === value.frequency); //si no es semanal no hara cambio
        }
      } else if (value.frequency === 'Mensual') {
        frequency = this.configCourt.filter(i => i.courtId === value.dayMonth);        //en estos casos busca el corte con el dia seleccionado en la segunda lista desplegable
      } else if (value.frequency === 'Días de la semana') {
        frequency = this.configCourt.filter(i => i.courtId === value.dayWeek);
      }
      const frequencyId =
      {
        courtId: frequency[0].courtId,
        updatedBy: localStorage.getItem('user_id')
      }

      const entityId = localStorage.getItem(Constant.entityId);
      console.log('Configuración De Corte A Guardar ', frequencyId);
      this.adminService.createCourtConfig(frequencyId, entityId).subscribe(data => {
        this.presentToast('Configuración de corte guardada');
        console.log('Esta Es La Configuración De Facturación Registrada', data);
        this.isFormPayments = true;
      }, error => {
        console.error('No se pudo realizar la configuración de cortes ', error);
        this.presentToast('No se pudo registrar la configuración de cortes');
      });
    } catch (error) {
      console.error('Error al guardar la configuración de cortes: ', error);
      this.presentToast('No se pudo registrar la configuración de cortes');
    } finally {
      loading.dismiss();
    }
  }

  async savePaymentMethod(value) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    loading.present();
    try {
      const payload = {
        entityId: localStorage.getItem(Constant.entityId),
        paymentMethodId: value.paymentMethod,
        settlementTypeId: value.billingMethod,
        updatedBy: localStorage.getItem('user_id'),
      };
      if (!this.validatePayload(payload)) {
        throw new Error('Información insuficiente, todos los campos deben estar completos');
      }
      this.authService.paymentMethodForEntity(payload).subscribe(response => {
        this.presentToast('Datos de facturación guardados con éxito');
        this.loading.present();
        this.isFormBilling = true;
      }, error => {
        console.error('No se pudo realizar la configuración de facturación: ', error);
        this.loading.dismiss();
        this.presentToast('No se pudo registrar la configuración de facturación');
      });
    } catch (error) {
      console.error('Error al guardar la configuración de facturación: ', error);
      this.presentToast('No se pudo registrar la configuración de facturación');
    } finally {
      loading.dismiss();
    }
  }


  filterConfigCourtByFrequency(selectedValue: string) {
    console.log('Recibo para filtro', selectedValue);
    this.filteredConfigCourt = [];
    let targetName;
    let configCourtCopy = this.originalConfigCourt.slice(); // Haciendo una copia de configCourt
    switch (selectedValue) {
      case 'Diario':
      case 'Quincenal':
        this.filteredConfigCourt.push(configCourtCopy.find(court => court.name === selectedValue));
        break;

      case 'Días de la semana':
        targetName = (selectedValue === 'Días de la semana') ? 'Semanal' : selectedValue;
        this.splitName(targetName, configCourtCopy); // Pasando la copia de configCourt
        break;

      case 'Mensual':
        this.splitName(selectedValue, configCourtCopy); // Pasando la copia de configCourt
        break;

      case 'Semanal':
        targetName = 'Semanal - Dia Domingo';
        this.splitName(targetName, configCourtCopy); // Pasando la copia de configCourt
        break;
    }
  }

  splitName(targetName, configCourtCopy) {
    for (const court of configCourtCopy) { // Usando la copia de configCourt
      if (court.name.startsWith(targetName)) {
        const splitName = court.name.split(' - ');
        if (splitName.length > 1) {
          const courtCopy = JSON.parse(JSON.stringify(court));
          courtCopy.name = splitName[1].trim(); // Modificar la copia profunda
          this.filteredConfigCourt.push(courtCopy);
        } else {
          this.filteredConfigCourt.push(court);
        }
      }
    }
  }

  validatePayload(payload: any): boolean {
    for (const key in payload) {
      if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
        return false;
      }
    }
    return true;
  }

  //METODO QUE RECIBE 3 IMAGENES INGRESADAS POR EL USUARIO Y LAS VALIDA
  async onFileSelected(event: any, index: number) {
    const inputElement = event.target.files[0];
    if (!inputElement) {
      console.warn('No se seleccionó un archivo');
      return;
    }

    this.originalFiles[index] = inputElement; //se almacena una copia de la imagen por si se desea recortar
    this.progress[index] = 0; // Reiniciar el contador de la barra
    this.showProgress[index] = true;
    this.showChargeIndicator(index);
    
    try {
      const isValidFile = await this.validateImage(inputElement); //validamos la extension y tamaño
      if (!isValidFile) {
        this.presentToast('La imagen seleccionada no cumple con los requisitos. Por favor, seleccione otra imagen e intente nuevamente.');
        this.clearFile(index);
        this.imagesCommerce[index] = null;
        return;
      }
      const isAspectValid = await this.imageValidationService.validateAspect(inputElement);   //valida la relacion de aspecto
      let finalFile: File;
      let newUrl: string;
      if (!isAspectValid) {
        console.log('La relación de aspecto es incorrecta, ajustando...');
        const croppedBlob = await this.imageValidationService.cropImage(inputElement, 4 / 3); //si la relacion de aspecto no es valida la ajustamos usando canvas
        console.log('La imagen recortada CroppedBlob ', croppedBlob);
        const croppedFile = new File([croppedBlob], inputElement.name, { type: inputElement.type });
        console.log('El archivo generado para la imagen recortada CroppedFile', croppedFile);
        finalFile = croppedFile;
        console.log('Archivo Final Recortado:', finalFile);
        if (Array.isArray(finalFile.name)) {
          console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen');
          newUrl = this.imageValidationService.createObjectURL(finalFile.name[0]);
        } else {
          console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen');
          newUrl = this.imageValidationService.createObjectURL(finalFile);
        }
        console.log('La url temporal creada para la imagen recortada: ', newUrl);
      } else {
        finalFile = inputElement;
        console.log('Archivo Final :', finalFile);
        newUrl = this.imageValidationService.createObjectURL(finalFile);  //creamos una nueva url temporal para evitar errores
        console.log('La url temporal creada: ', newUrl);
      }

      this.imagesCommerce[index] = {      //Creo un elemento del arreglo con los datos de la imagen cargada
        file: finalFile,
        url: this.sanitizer.bypassSecurityTrustUrl(newUrl),
        typePhoto: this.typePhotos[index].typeFileId
      };

    } catch (error) {
      console.error('Error al procesar la imagen:', error);
      this.clearFile(index);
      console.warn('No se han cargado archivos');
      this.imagesCommerce[index] = null;
    }
  }

  async cropImage(index: number) {
    if (this.imagesCommerce[index]?.file && this.originalFiles[index]) {      //se verifica que exista la imagen en el arreglo de imagenes de comercio e imagenes originales

      //se recorta la imagen original
      let newUrl;
      const file = this.originalFiles[index];
      console.log('el archivo original: ', file);
      const croppedBlob = await this.imageValidationService.cropImage(file, 4 / 3);
      console.log('La imagen recortada CroppedBlob ', croppedBlob);
      const croppedFile = new File([croppedBlob], file.name, { type: file.type });
      console.log('La imagen recortada: ', croppedFile);
      const finalFile = croppedFile;  //al parecer aca se encuentra el blob de la foto teniendo en cuenta que el objeto croppedFile es diferente en localhost que en los ambientes develop-prod
      if (Array.isArray(finalFile.name)) {
        console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen');
        newUrl = this.imageValidationService.createObjectURL(finalFile.name[0]);
      } else {
        console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen');
        newUrl = this.imageValidationService.createObjectURL(finalFile);
      }
      this.imagesCommerce[index].url = this.sanitizer.bypassSecurityTrustUrl(newUrl);
      this.imagesCommerce[index].file = finalFile;
      console.log('el elemento del arreglo despues del recorte:', this.imagesCommerce[index]);
    } else {
      console.warn('No se encontro la imagen original para recortar.');
    }
  }


  getImageUrl(index: number): SafeUrl {
    return this.imagesCommerce[index]?.url;
  }

  async validateImage(file: File): Promise<boolean> {
    const validSize = this.imageValidationService.validateSizeFile(file);
    if (!validSize) {
      this.presentToast('El tamaño en MB de la imagen seleccionada es mayor al permitido. Por favor, seleccione una imagen más pequeña.');
      return false;
    }
    const validExtension = this.imageValidationService.validateExtension(file);
    if (!validExtension) {
      this.presentToast('El tipo de archivo seleccionado no es una imagen. Por favor, seleccione otro archivo');
      return false;
    }
    return true;
  }


  clearFile(index: number) {
    console.log("Llama al metodo clearFile para logo")
    if (this.selectedCategory === 5) {
      // Limpia la imagen única (logo)
      this.LogoImage = null;
      this.progress[0] = 0;
      this.showProgress[0] = false;
      this.fileName[0] = null;
      this.originalFiles[0] = null;

      // Reinicia el input de archivo
      const inputElement = document.getElementById('logoInput') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = ''; // Limpiar el valor del input
      }
    } else {
      this.imagesCommerce[index] = null;
      this.progress[index] = 0;
      this.showProgress[index] = false;
      this.fileName[index] = null;
      this.originalFiles[index] = null;
      this.imageValidationService.revokeObjectURL();
      // Reinicia el input de archivo correspondiente
      const inputElement = document.getElementById(`input-file-${index}`) as HTMLInputElement;
      if (inputElement) {
        inputElement.value = ''; // Limpiar el valor del input
      }
    }
  }

  async showChargeIndicator(index: number) {
    return new Promise<void>((resolve) => {
      const incrementInterval = setInterval(() => {
        this.progress[index] += 0.035;
        if (this.progress[index] >= 1) {
          clearInterval(incrementInterval); // Detener el incremento cuando alcanza 100%
          resolve(); // Resuelve la promesa cuando el progreso llega al 100%
        }
      }, 100);
    });
  }

  async presentPopover(ev: Event) {
    if (this.popover) {
      await this.dismissPopover();
    } else {
      const popover = await this.popoverController.create({
        component: PopoverContentComponent,
        componentProps: {
          title: this.popoverTitle,
          message: this.selectedCategory !== 5 ? this.popoverMessage1 : this.popoverMessage3,
          message2: this.selectedCategory !== 5 ? this.popoverMessage2 : this.popoverMessage4,
        },
        event: ev,
        showBackdrop: false,
        backdropDismiss: true,
        mode: 'ios',
        animated: true
      });

      this.popover = popover;

      // Listener para clics dentro del popover y en el ícono
      this.popover.onDidDismiss().then(() => {
        this.popover = null;
      });

      await popover.present();
    }
  }


  async dismissPopover() {
    if (this.popover) {
      await this.popover.dismiss();
      this.popover = null;
    }
  }


  async validateUsername(event, typeNetwork, index) {
    this.validationStatus[index] = true;
    this.socialNetworkn[index].account = await this.userValidationService.controlLength(event, typeNetwork)
    this.validationStatus[index] = await this.userValidationService.validateRedSocial(this.socialNetworkn[index].account, typeNetwork);
    this.validRed = this.isAllValid();
  }

  isAllValid(): boolean {
    return Object.values(this.validationStatus).every(status => status);
  }

  onCategoryChange(event: any) {
    this.selectedCategory = event.detail.value;
    console.log("La categoria seleccionada es ", this.selectedCategory);
  }


  uploadLogos(event: any) {
    this.loading.present();
    if (event.target.files[0]) {
      const inputElement = event.target.files[0];
      this.fileType = inputElement.type;
      console.log("Archivo Cargado: ", inputElement);

      // Corregir la relación de aspecto
      this.imageValidationService.correctAspectRatio(inputElement, 1 / 1).then(async ({ blob, width, height }) => {
        this.finalFileLogo = new File([blob], inputElement.name, { type: inputElement.type });
        const identity = localStorage.getItem(Constant.entityId);

        // Mostrar las dimensiones de la imagen ajustada
        console.log("Dimensiones de la imagen ajustada", width, "y", height, "y el IdEntity", localStorage.getItem(Constant.entityId));

        // 3. Crear URL temporal para la previsualización de la imagen ajustada
        let newUrl;
        if (Array.isArray(this.finalFileLogo.name)) {
          console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen para el backend');
          newUrl = this.imageValidationService.createObjectURL(this.finalFileLogo.name[0]);
        } else {
          console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen para el backend');
          newUrl = this.imageValidationService.createObjectURL(this.finalFileLogo);
        }
        console.log('URL temporal creada:', newUrl);

        // 4. Asignar la imagen a la propiedad que maneja la previsualización (LogoImage)
        this.LogoImage = {
          file: this.finalFileLogo,
          url: this.sanitizer.bypassSecurityTrustUrl(newUrl),
          name: inputElement.name
        };

        // 5. Mostrar la imagen en la interfaz
        console.log("LogoImage asignado correctamente:", newUrl);

        this.loading.dismiss(); // Finaliza el loading después de completar el proceso

      }).catch(error => {
        console.log("Error al corregir la imagen:", error);
        this.clearFile(0);  // Limpia el archivo en caso de error
        this.loading.dismiss();
      });
    }
  }


}
